module.exports = __webpack_public_path__ + "static/img/2_0.aa290c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/2_0.png
// module id = v5se
// module chunks = 0